import React, { useState, useEffect, useRef } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./update_venue.css";
import Select from "react-select";
import "../../Api/apiUrls";
import { UpdateAdminVenueFAQ } from "../../Api/apiUrls";
import { UpdateAdminVenueSlot } from "../../Api/apiUrls";
import {
  UpdateAdminVenue,
  API_URL,
  getCategories,
  getAdminLocationArea,
  getAdminLocationCity,
  addFaqPage,
  getFaqByVenueId,
  getAdminVenueFAQById,
  deleteAdminVenueFAQ,
  addBookingSlot,
  getBookingSlotByVenueId,
  getBookingSlotById,
  deleteBookingSlotById,
} from "../../Api/apiUrls";

function Update_venue({
  venueId,
  venueName,
  venueShort,
  venueDescription,
  venueInclusion,
  venueCategory,
  venueCancellation,
  venueseats,
  venueDuration,
  venuePrice,
  venueAddress,
  venueAddress2,
  venueCity,
  venueLocation,
  venuePostal,
  venueGoogle,
  venueEmail,
  venuePhone,
  venueWebsite,
  venueStatus,
  venueVenueOwner,
  onClose,
}) {
  console.log(venueId);

  const [modalUpdate_venueIsOpen, setUpdate_venueModalIsOpen] = useState("");
  const [showFields, setShowFields] = useState(false);
  const [showFields2, setShowFields2] = useState(false);
  const [Question, setQuestion] = useState("");
  const [Answer, setAnswer] = useState("");
  const [isAddingFaq, setIsAddingFaq] = useState(false);
  const [newFaqAnswer, setNewFaqAnswer] = useState(Answer);
  const [newFaqQuestion, setNewFaqQuestion] = useState(Question);
  const [id, setId] = useState("");
  const [categories, setCategories] = useState([]);
  const [location, setLocation] = useState([]);
  const [city, setCity] = useState([]);
  const [dateTime, setDateTime] = useState("");
  const [showFields3, setShowFields3] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdatingFaq, setIsUpdatingFaq] = useState(false);
  const [bookingDate, setBookingDate] = useState("");
  const [bookingStartTime, setBookingStartTime] = useState("");
  const [bookingEndTime, setBookingEndTime] = useState("");
  const [bookingPrice, setBookingPrice] = useState("");
  const [bookingCapacity, setBookingCapacity] = useState("");
  const [isAddingBookingSlot, setIsAddingBookingSlot] = useState(false);
  const [bookingNewDate, setBookingNewDate] = useState("");
  const [bookingNewStartTime, setBookingNewStartTime] = useState("");
  const [bookingNewEndTime, setBookingNewEndTime] = useState("");
  const [bookingNewPrice, setBookingNewPrice] = useState("");
  const [bookingNewCapacity, setBookingNewCapacity] = useState("");
  const [id2, setId2] = useState("");
  const [isUpdatingSlot, setIsUpdatingSlot] = useState(false);
  const [showFields4, setShowFields4] = useState(false);
  const [isUpdatingWorkshop, setIsUpdatingWorkshop] = useState(true);

  const [venueNewName, setNewVenueName] = useState(venueName);
  const [venueNewShortDescription, setNewVenueShortDescription] =
    useState(venueShort);
  const [venueNewDescription, setNewVenueDescription] =
    useState(venueDescription);
  const [venueNewInclusion, setNewVenueInclusion] = useState(venueInclusion);
  const [venueNewCancellation, setNewVenueCancellation] =
    useState(venueCancellation);
  const [venueNewSeats, setNewVenueSeats] = useState(venueseats);
  const [venueNewDuration, setNewVenueDuration] = useState(venueDuration);
  const [venueNewPrice, setNewVenuePrice] = useState(venuePrice);
  const [venueNewAddress, setNewVenueAddress] = useState(venueAddress);
  const [venueNewAddress2, setNewVenueAddress2] = useState(venueAddress2);
  const [venueNewPostalCode, setNewVenuePostalCode] = useState(venuePostal);
  const [venueNewGoogleCode, setNewVenueGoogleCode] = useState(venueGoogle);
  const [venueNewEmail, setNewVenueEmail] = useState(venueEmail);
  const [venueNewPhone, setNewVenuePhone] = useState(venuePhone);
  const [venueNewWebsite, setNewVenueWebsite] = useState(venueWebsite);
  // const [venueStatus, setvenueStatus] = useState(venueStatus);
  const [newVenueStatus, setNewVenueStatus] = useState(venueStatus);
  const [selectedVenueOwner, setSelectedVenueOwner] = useState(venueVenueOwner);
  const [venueOwner, setVenueOwner] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedCity, setSelectedCity] = useState(venueCity);
  const handleAddClick = (event) => {
    event.preventDefault();
    const currentDateTime = getCurrentDateTime();
    setDateTime(currentDateTime);
    console.log(currentDateTime);
    setShowFields(true);
  };

  const handleCancelClick = () => {
    setShowFields(false);
  };

  const handleAddClick2 = (event) => {
    event.preventDefault();
    setShowFields2(true);
  };

  const handleCancelClick2 = () => {
    setShowFields2(false);
  };
  const handleCancelClick3 = () => {
    setShowFields3(false);
  };
  const handleCancelClick4 = () => {
    setShowFields4(false);
  };

  const closeUpdate_venue = () => {
    setUpdate_venueModalIsOpen(false);
  };
  const Category = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];

  function reloadPage() {
    window.location.reload();
  }

  const handleClick = (e) => {
    if (e.currentTarget === e.target) {
      onClose();
      reloadPage();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);
  // const city = [
  //   { value: "Yes", label: "Yes" },
  //   { value: "No", label: "No" },
  // ];
  const area = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];
  const homepage = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];
  const Status = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  function reloadPage() {
    window.location.reload();
  }

  function getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    // const milliseconds = String(now.getMilliseconds()).padStart(3, "0");

    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
  }

  const handleStatusChange = (selectedOption) => {
    setNewVenueStatus(selectedOption);
  };
  const [filteredAreas, setFilteredAreas] = useState([]);
  useEffect(() => {
    if (selectedCity && selectedCity.value) {
      // Check if a city is selected
      console.log(selectedCity);
      const filteredAreasResult = location.filter(
        (location) => location.city.id === selectedCity.value
      );
      setFilteredAreas(filteredAreasResult);
    }
  }, [selectedCity, location]);
  // -----------------get category-------------------------------------------
  const [selectedCategories, setSelectedCategories] = useState(venueCategory);
  useEffect(() => {
    fetch(`${getCategories}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (Array.isArray(data.data.Categories)) {
            // Filter categories by type 'Workshop'
            const workshopCategories = data.data.Categories.filter(
              (category) => category.type === "Venue"
            );
            setCategories(workshopCategories);
          } else {
            console.error(
              "Categories data is not an array:",
              data.data.Categories
            );
          }
        } else {
          console.error("Error fetching category:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching category:", error);
      });
  }, []);

  const categoryOptions = categories.map((category) => ({
    value: category.id,
    label: category.name,
  }));

  const handleCategoryChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedCategories(selectedOptions);
    // setaa([selectedOptions.label])

    console.log(selectedOptions);
  };

  // ---------------------------get area---------------------------------
  const [selectedLocation, setSelectedLocation] = useState(venueLocation);

  useEffect(() => {
    fetch(`${getAdminLocationArea}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (Array.isArray(data.data.LocationArea)) {
            setLocation(data.data.LocationArea);
          } else {
            console.error("City data is not an array:", data.data.LocationArea);
          }
        } else {
          console.error("Error fetching area:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching area:", error);
      });
  }, []);

  const areaOptions = filteredAreas.map((location) => ({
    value: location.id,
    label: location.name,
  }));
  const handleAreaChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);

    console.log(selectedOptions);
  };

  // -----------------get city-------------------------------------------

  useEffect(() => {
    fetch(`${getAdminLocationCity}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (Array.isArray(data.data.LocationCity)) {
            setCity(data.data.LocationCity);
          } else {
            console.error("City data is not an array:", data.data.LocationCity);
          }
        } else {
          console.error("Error fetching city:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching city:", error);
      });
  }, []);

  const cityOptions = city.map((city) => ({
    value: city.id,
    label: city.name,
  }));

  const handleCityChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedCity(selectedOptions);

    console.log(selectedOptions);
  };

  // --------------------------------------add  Faqs-------------------------------------------------------------
  const [faq, setFaq] = useState(false);
  const handleAddFAQ = async (event) => {
    try {
      event.preventDefault();

      if (!Question) {
        alert("Please fill in all fields");
        return;
      }

      setIsAddingFaq(true);

      const formData = new FormData();
      formData.append("temp_id", dateTime);
      formData.append("type", "Venue");
      formData.append("question", Question);
      formData.append("answer", Answer);
      formData.append("venue", venueId);

      const addResponse = await fetch(`${addFaqPage}`, {
        method: "POST",
        body: formData,
      });

      if (!addResponse.ok) {
        alert("Failed to add FAQ's");
        return;
      } else {
      }
      const getResponse = await fetch(`${getFaqByVenueId}${venueId}`);

      if (!getResponse.ok) {
        alert("Failed to fetch FAQs");
        return;
      }

      const getData = await getResponse.json();
      const faqData = getData.data.FAQ || [];

      setFaq(faqData);
      setShowFields(false);
      setQuestion("");
      setAnswer("");
    } catch (error) {
      console.error("Error handling FAQ:", error);
    } finally {
      setIsAddingFaq(false);
    }
  };

  // ---------------------------------- get faqs------------------------------------------------------------------------

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${getFaqByVenueId}${venueId}`);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        const faqData = data.data.FAQ || [];

        setFaq(faqData);
        setShowFields(false);
        setQuestion("");
        setAnswer("");
      } catch (error) {
        console.error("Error handling FAQ:", error);
      } finally {
        setIsAddingFaq(false);
      }
    };

    fetchData();
  }, [venueId]);

  // ------------------------------------------get faq by id-----------------------------------------------

  const handleClick3 = (id) => {
    // event.preventDefault();

    fetch(`${getAdminVenueFAQById}${id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const bookingFaq = data.data.FAQ;
        console.log("each", bookingFaq);
        // setEachSlot(bookingFaq);
        setNewFaqAnswer(bookingFaq.answer);
        setNewFaqQuestion(bookingFaq.question);
        // setDatetime(bookingFaq.temp_id);
        setId(bookingFaq.id);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
      });

    setShowFields3(true);
  };

  // --------------------------------------------update faqs-----------------------------------------------------------------------------

  const handleUpdateFaq = async (id) => {
    try {
      setIsUpdatingFaq(true);

      const formData = new FormData();
      formData.append("faq_id", id);
      // formData.append("temp_id", datetime);
      formData.append("question", newFaqQuestion);
      formData.append("answer", newFaqAnswer);

      const updateResponse = await fetch(UpdateAdminVenueFAQ, {
        method: "PUT",
        body: formData,
      });

      if (!updateResponse.ok) {
        alert("Failed to update FAQ");
        return;
      }

      // Trigger get API after update
      const getResponse = await fetch(`${getFaqByVenueId}${venueId}`);

      if (!getResponse.ok) {
        alert("Failed to fetch FAQs");
        return;
      }

      const getData = await getResponse.json();
      const updatedFaqData = getData.data.FAQ || [];

      setFaq(updatedFaqData);
      setShowFields3(false);
    } catch (error) {
      console.error("Error updating FAQ:", error);
    } finally {
      setIsUpdatingFaq(false);
    }
  };

  // ----------------------------delete faqs-----------------------------------------------

  const handleDeleteFaq = (id) => {
    fetch(`${deleteAdminVenueFAQ}${id}`, {
      method: "DELETE",
      headers: {
        accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Check if the delete operation was successful
        if (data.success) {
          // Trigger the get API after successful deletion
          return fetch(`${getFaqByVenueId}${venueId}`);
        } else {
          // Handle the error if the delete operation was not successful
          console.error("Error deleting FAQ:", data.message);
        }
      })
      .then((getResponse) => {
        // Check if the get API response is successful
        if (getResponse && getResponse.ok) {
          return getResponse.json();
        } else {
          throw new Error("Failed to fetch FAQ");
        }
      })
      .then((getData) => {
        // Update the table with the fetched data
        const updatedFaqData = getData.data.FAQ || [];
        setFaq(updatedFaqData);
      })
      .catch((error) => {
        console.error("Error handling FAQ:", error);
      });
  };

  // ------------------------add workshop slot ------------------------------------------------------------

  const [bookingSlot, setBookingSlot] = useState([]);
  const handleAddBookingSlot = async (event) => {
    try {
      event.preventDefault();

      if (!bookingDate) {
        alert("Please fill in all fields");
        return;
      }

      setIsAddingBookingSlot(true);

      const formData = new FormData();
      formData.append("startDate", bookingDate);
      formData.append("startTime", bookingStartTime);
      formData.append("endTime", bookingEndTime);
      formData.append("price", bookingPrice);
      formData.append("temp_id", dateTime);
      formData.append("capacity", bookingCapacity);
      formData.append("availableSeats", bookingCapacity);
      formData.append("venue", venueId);
      formData.append("changed_by", "Admin");

      const addResponse = await fetch(`${addBookingSlot}`, {
        method: "POST",
        body: formData,
      });

      if (!addResponse.ok) {
        alert("Failed to add slot");
        return;
      }
      const getResponse = await fetch(`${getBookingSlotByVenueId}${venueId}`);

      if (!getResponse.ok) {
        alert("Failed to fetch slot");
        return;
      }

      const getData = await getResponse.json();
      const bookingSlot = getData.data.BookingSlot || [];

      setBookingSlot(bookingSlot);
      setShowFields2(false);
      setBookingDate("");
      setBookingStartTime("");
      setBookingEndTime("");
      setBookingPrice("");
      setBookingCapacity("");
    } catch (error) {
      console.error("Error handling FAQ:", error);
    } finally {
      setIsAddingBookingSlot(false);
    }
  };

  // ---------------------------------- get Booking slot------------------------------------------------------------------------

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${getBookingSlotByVenueId}${venueId}`);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const getResponse = await response.json(); // Corrected this line
        const bookingSlot = getResponse.data.BookingSlot || []; // Corrected this line

        setBookingSlot(bookingSlot);
        setShowFields2(false);
        setBookingDate("");
        setBookingStartTime("");
        setBookingEndTime("");
        setBookingPrice("");
        setBookingCapacity("");
      } catch (error) {
        console.error("Error handling FAQ:", error);
      } finally {
        setIsAddingBookingSlot(false);
      }
    };

    fetchData();
  }, [venueId]);

  // ---------------------------------get booking slot by id --------------------------------------------------------

  const handleClick4 = (id2) => {
    // event.preventDefault();

    fetch(`${getBookingSlotById}${id2}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const bookingEachSlot = data.data.BookingSlot;
        setBookingNewDate(bookingEachSlot.startDate);
        setBookingNewStartTime(bookingEachSlot.startTime);
        setBookingNewEndTime(bookingEachSlot.endTime);
        setBookingNewPrice(bookingEachSlot.price);
        setBookingNewCapacity(bookingEachSlot.capacity);
        // setDatetime(bookingEachSlot.temp_id);
        setId2(bookingEachSlot.id);
        console.log(bookingEachSlot.id);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
      });

    setShowFields4(true);
  };

  // -------------------------update wokshop slot ----------------------------------------------------------------

  const handleUpdateWorkshop = async (id2) => {
    try {
      setIsUpdatingSlot(true);

      const formData = new FormData();
      formData.append("bookingSlot_id", id2);
      formData.append("temp_id", dateTime);
      formData.append("StartDate", bookingNewDate);
      formData.append("startTime", bookingNewStartTime);
      formData.append("endTime", bookingNewEndTime);
      formData.append("price", bookingNewPrice);
      formData.append("capacity", bookingNewCapacity);
      formData.append("changed_by", "Admin");

      const updateResponse = await fetch(UpdateAdminVenueSlot, {
        method: "PUT",
        body: formData,
      });

      if (!updateResponse.ok) {
        alert("Failed to update slot");
        return;
      }

      // Trigger get API after update
      const getResponse = await fetch(`${getBookingSlotByVenueId}${venueId}`);

      if (!getResponse.ok) {
        alert("Failed to fetch slot");
        return;
      }

      const getData = await getResponse.json();
      const bookingSlot = getData.data.BookingSlot || [];

      setBookingSlot(bookingSlot);
      setShowFields4(false);
    } catch (error) {
      console.error("Error handling slot:", error);
    } finally {
      setIsUpdatingSlot(false);
    }
  };

  // ---------------------------delete workshop slot ------------------------------------

  const handleDeleteWorkshop = (id2) => {
    fetch(`${deleteBookingSlotById}${id2}&changed_by=Admin`, {
      method: "DELETE",
      headers: {
        accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Check if the delete operation was successful
        if (data.success) {
          // Trigger the get API after successful deletion
          return fetch(`${getBookingSlotByVenueId}${venueId}`);
        } else {
          // Handle the error if the delete operation was not successful
          alert( data.message);
        }
      })
      .then((getResponse) => {
        // Check if the get API response is successful
        if (getResponse && getResponse.ok) {
          return getResponse.json();
        } else {
          throw new Error("Failed to fetch slot");
        }
      })
      .then((getData) => {
        const bookingSlot = getData.data.BookingSlot || [];
        setBookingSlot(bookingSlot);
      })
      .catch((error) => {
        console.error("Error handling slot:", error);
      });
  };

  // -------------------------Update VenueOwner DropDown-------------------------------------------------
  useEffect(() => {
    // Fetch data from the API
    fetch(`${API_URL}/user/get-venue_owner/`)
      .then((response) => response.json())
      .then((data) => {
        // Extract relevant data from the response
        const options = data.data.users.map((user) => ({
          value: user.id,
          label: user.name,
          image: `${API_URL}/${user?.profile_image}`,
        }));
        setVenueOwner(options);
        setFilteredOptions(options); // Initially, set filtered options to all options
        setIsLoading(false);
      })
      .catch((error) => console.error("Error fetching instructors:", error));
  }, []);

  const handleInputChange = (newValue) => {
    setSearchValue(newValue);
    // filterOptions(newValue);
  };

  // const filterOptions = (inputValue) => {
  //   const filtered = venueOwner.filter((option) =>
  //     option.label.toLowerCase().includes(inputValue.toLowerCase())
  //   );
  //   setFilteredOptions(filtered);
  //   console.log(filtered);
  // };

  const handleVenueOwnerChange = (selectedOption) => {
    setSelectedVenueOwner(selectedOption);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // -------------------------update venue-------------------------------------------------------------------------

  const handleUpdate = () => {
    setIsUpdatingWorkshop(true);

    const formData = new FormData();
    formData.append("Venue_id", venueId);
    formData.append("name", venueNewName);
    formData.append("description", venueNewDescription);
    formData.append("short_description", venueNewShortDescription);
    formData.append("inclusion_amenities", venueNewInclusion);
    formData.append("cancellation_policy", venueNewCancellation);
    formData.append("capacity", venueNewSeats);
    formData.append("duration", venueNewDuration);
    formData.append("price", venueNewPrice);
    formData.append("address_line1", venueNewAddress);
    formData.append("address_line2", venueNewAddress2);
    formData.append("area", selectedLocation.value);
    formData.append("city", selectedCity.value);
    formData.append("pincode", venueNewPostalCode);
    formData.append("google_location_link", venueNewGoogleCode);
    formData.append("email", venueNewEmail);
    formData.append("mobileNumber", venueNewPhone);
    formData.append("website", venueNewWebsite);
    formData.append("category", selectedCategories.value);
    formData.append("status", newVenueStatus.label);
    formData.append("venue_owner", selectedVenueOwner.value);
    formData.append("changed_by", "Admin");
    // formData.append("city", selectedCity.value);
    // if (selectedLocation && selectedLocation.length > 0) {
    //   formData.append("area", selectedLocation[0].value);
    // } else {
    //   console.error("selectedLocation is undefined or empty");
    // }

    fetch(UpdateAdminVenue, {
      method: "PUT",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          alert("Updated");
          setIsUpdatingWorkshop(false);

          window.location.reload();
          onClose();
        } else {
          console.error("Error updating venue:", data.message);
          setIsUpdatingWorkshop(false);
        }
      })
      .catch((error) => {
        console.error("Error updating venue:", error);
        setIsUpdatingWorkshop(false);
      });
  };

  return (
    <div>
      {modalUpdate_venueIsOpen && <Update_venue onClose={closeUpdate_venue} />}
      <div className="popup-background">
        <div className="popup">
          <div
            class="modal-content"
            style={{
              width: "100%",
              height: "80%",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
              // overflowY: "scroll",
            }}
          >
            <div
              class="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                class="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Update Venue</b>
              </h5>

              <button
                type="button"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              class="modal-body"
              style={{ overflowY: "scroll", padding: "2%" }}
            >
              <form>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Name of Venue:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewName}
                    onChange={(e) => setNewVenueName(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Short Description:<font color="red"></font>
                  </label>
                  <textarea
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewShortDescription}
                    onChange={(e) =>
                      setNewVenueShortDescription(e.target.value)
                    }
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Description:<font color="red"></font>
                  </label>
                  <textarea
                    class="form-control"
                    id="inputFullName"
                    type="description"
                    placeholder=""
                    value={venueNewDescription}
                    onChange={(e) => setNewVenueDescription(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Inclusion Ammenities:<font color="red"></font>
                  </label>
                  <textarea
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=" "
                    value={venueNewInclusion}
                    onChange={(e) => setNewVenueInclusion(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Cancellation Policy:<font color="red"></font>
                  </label>
                  <textarea
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewCancellation}
                    onChange={(e) => setNewVenueCancellation(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Category <font color="red"></font>
                  </label>

                  <Select
                    options={categoryOptions}
                    value={selectedCategories}
                    onChange={handleCategoryChange}
                  ></Select>
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Duration in Hrs:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewDuration}
                    onChange={(e) => setNewVenueDuration(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Capacity:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewSeats}
                    onChange={(e) => setNewVenueSeats(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Price:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewPrice}
                    onChange={(e) => setNewVenuePrice(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Address Line1:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewAddress}
                    onChange={(e) => setNewVenueAddress(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Address Line2:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewAddress2}
                    onChange={(e) => setNewVenueAddress2(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Select City<font color="red"></font>
                  </label>
                  <Select
                    options={cityOptions}
                    value={selectedCity}
                    onChange={handleCityChange}
                  ></Select>
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Select Area <font color="red"></font>
                  </label>
                  <Select
                    options={areaOptions}
                    value={selectedLocation}
                    onChange={handleAreaChange}
                  ></Select>
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Postal Code:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewPostalCode}
                    onChange={(e) => setNewVenuePostalCode(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Google Code:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewGoogleCode}
                    onChange={(e) => setNewVenueGoogleCode(e.target.value)}
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Email:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="email"
                    placeholder=""
                    value={venueNewEmail}
                    onChange={(e) => setNewVenueEmail(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Phone:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewPhone}
                    onChange={(e) => setNewVenuePhone(e.target.value)}
                  />
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Website:<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                    value={venueNewWebsite}
                    onChange={(e) => setNewVenueWebsite(e.target.value)}
                  />
                </div>
                <div>
                  <div className="form-group">
                    <label className="small mb-1" htmlFor="inputFullName">
                      FAQ's<font color="red"></font>
                    </label>
                    <button
                      style={{
                        marginLeft: "10px",
                        fontSize: "14px",
                        borderRadius: "4px",
                        backgroundColor: "#000",
                        color: "#fff",
                      }}
                      onClick={handleAddClick}
                    >
                      + Add
                    </button>
                  </div>
                  {showFields && (
                    <>
                      <div
                        class="col-md-12"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="form-group col-md-6">
                          <label className="small mb-1" htmlFor="inputFullName">
                            Enter Question<font color="red"></font>
                          </label>
                          <input
                            className="form-control"
                            id="inputFullName"
                            type="text"
                            value={Question}
                            onChange={(e) => setQuestion(e.target.value)}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label className="small mb-1" htmlFor="inputFullName">
                            Enter Answer<font color="red"></font>
                          </label>
                          <input
                            className="form-control"
                            id="inputFullName"
                            type="text"
                            value={Answer}
                            onChange={(e) => setAnswer(e.target.value)}
                          />
                        </div>
                      </div>
                      <div style={{ display: "flex", marginBottom: "20px" }}>
                        <button
                          type="submit"
                          style={{
                            marginLeft: "10px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            backgroundColor: "#000",
                            color: "#fff",
                            border: "none",
                            padding: "5px 20px",
                          }}
                          onClick={handleAddFAQ}
                        >
                          Add
                        </button>
                        <button
                          type="button"
                          onClick={handleCancelClick}
                          style={{
                            marginLeft: "10px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            backgroundColor: "lightgrey",
                            color: "#000",
                            border: "none",
                            padding: "5px 20px",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}
                </div>

                <div className="table-responsive">
                  {Array.isArray(faq) && faq.length > 0 ? (
                    <table
                      className="table table-striped"
                      style={{ padding: "0rem" }}
                    >
                      <thead>
                        <tr>
                          <th scope="col">Sr.No</th>
                          <th scope="col">Question</th>
                          <th scope="col">Answer</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {faq.map((faqItem, index) => (
                          <tr key={faqItem.id}>
                            <th scope="row">{index + 1}</th>
                            <td>
                              <b>{faqItem.question || "-"}</b>
                            </td>
                            <td>
                              <b>{faqItem.answer || "-"}</b>
                            </td>
                            <td>
                              <div className="social-links mt-2">
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClick3(faqItem.id)}
                                >
                                  <i className="bi bi-pencil"></i>
                                </a>
                                &nbsp;&nbsp;
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleDeleteFaq(faqItem.id)}
                                >
                                  <i className="bi bi-trash3"></i>
                                </a>
                                &nbsp;
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <h3 style={{ textAlign: "center" }}></h3>
                  )}
                </div>

                {showFields3 && (
                  <div>
                    <>
                      <div>
                        <div
                          class="col-md-12"
                          style={{ display: "flex", paddingLeft: "0px" }}
                        >
                          <div
                            class="form-group col-md-6"
                            style={{ paddingLeft: "0px" }}
                          >
                            <label class="small mb-1" for="inputFullName">
                              Question<font color="red"></font>
                            </label>
                            <input
                              class="form-control"
                              id="inputFullName"
                              type="text"
                              // value={eachSlot.startDate}
                              value={newFaqQuestion}
                              onChange={(e) =>
                                setNewFaqQuestion(e.target.value)
                              }
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <label class="small mb-1" for="inputFullName">
                              Answer <font color="red"></font>
                            </label>
                            <input
                              class="form-control"
                              id="inputFullName"
                              type="text"
                              // value={eachSlot.startTime}
                              value={newFaqAnswer}
                              onChange={(e) => setNewFaqAnswer(e.target.value)}
                            />
                          </div>
                        </div>

                        <div style={{ display: "flex", marginBottom: "20px" }}>
                          <button
                            type="button"
                            style={{
                              marginLeft: "10px",
                              fontSize: "14px",
                              borderRadius: "4px",
                              backgroundColor: "#000",
                              color: "#fff",
                              border: "none",
                              padding: "5px 20px",
                            }}
                            onClick={() =>
                              handleUpdateFaq(id, newFaqAnswer, newFaqQuestion)
                            }
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            onClick={handleCancelClick3}
                            style={{
                              marginLeft: "10px",
                              fontSize: "14px",
                              borderRadius: "4px",
                              backgroundColor: "lightgrey",
                              color: "#000",
                              border: "none",
                              padding: "5px 20px",
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </>
                  </div>
                )}

                {/* <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Booking Slots:<font color="red"></font>
                  </label>
                  <button
                    style={{
                      marginLeft: "10px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      backgroundColor: "#000",
                      color: "#fff",
                    }}
                    onClick={handleAddClick2}
                  >
                    + Add
                  </button>
                </div> */}
                {showFields2 && (
                  <>
                    <div
                      class="col-md-12"
                      style={{ display: "flex", paddingLeft: "0px" }}
                    >
                      <div
                        class="form-group col-md-6"
                        style={{ paddingLeft: "0px" }}
                      >
                        <label class="small mb-1" for="inputFullName">
                          Select Date<font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="date"
                          value={bookingDate}
                          onChange={(e) => setBookingDate(e.target.value)}
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="small mb-1" for="inputFullName">
                          Select Start time <font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="time"
                          value={bookingStartTime}
                          onChange={(e) => setBookingStartTime(e.target.value)}
                        />
                      </div>
                    </div>
                    <div
                      class="col-md-12"
                      style={{ display: "flex", paddingLeft: "0px" }}
                    >
                      <div
                        class="form-group col-md-6"
                        style={{ paddingLeft: "0px" }}
                      >
                        <label class="small mb-1" for="inputFullName">
                          Select End Time<font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="time"
                          value={bookingEndTime}
                          onChange={(e) => setBookingEndTime(e.target.value)}
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="small mb-1" for="inputFullName">
                          Enter Price <font color="red"></font>
                        </label>
                        <input
                          class="form-control"
                          id="inputFullName"
                          type="number"
                          value={bookingPrice}
                          onChange={(e) => setBookingPrice(e.target.value)}
                        />
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="small mb-1" for="inputFullName">
                        Enter Available Seats<font color="red"></font>
                      </label>
                      <input
                        class="form-control"
                        id="inputFullName"
                        type="number"
                        placeholder=""
                        value={bookingCapacity}
                        onChange={(e) => setBookingCapacity(e.target.value)}
                      />
                    </div>
                    <div style={{ display: "flex", marginBottom: "20px" }}>
                      <button
                        type="submit"
                        style={{
                          marginLeft: "10px",
                          fontSize: "14px",
                          borderRadius: "4px",
                          backgroundColor: "#000",
                          color: "#fff",
                          border: "none",
                          padding: "5px 20px",
                        }}
                        onClick={handleAddBookingSlot}
                      >
                        Add
                      </button>
                      <button
                        type="button"
                        onClick={handleCancelClick2}
                        style={{
                          marginLeft: "10px",
                          fontSize: "14px",
                          borderRadius: "4px",
                          backgroundColor: "lightgrey",
                          color: "#000",
                          border: "none",
                          padding: "5px 20px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                )}

                {/* <div className="table-responsive">
                  {Array.isArray(bookingSlot) && bookingSlot.length > 0 ? (
                    <table
                      className="table table-striped"
                      style={{ padding: "0rem" }}
                    >
                      <thead>
                        <tr>
                          <th scope="col">Sr.No</th>
                          <th scope="col">Start Date</th>
                          <th scope="col">Start Time</th>
                          <th scope="col">End Time</th>
                          <th scope="col">Price</th>
                          <th scope="col">Seating Capacity</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookingSlot.map((bookingSlot, index) => (
                          <tr key={bookingSlot.id}>
                            <th scope="row">{index + 1}</th>
                            <td>
                              <b>{bookingSlot.startDate || "---"}</b>
                            </td>
                            <td>
                              <b>{bookingSlot.startTime}</b>
                              <br />
                            </td>
                            <td>
                              <b>{bookingSlot.endTime}</b>
                              <br />
                            </td>
                            <td>
                              <b>{bookingSlot.price || "---"}</b>
                              <br />
                            </td>
                            <td>
                              <b>{bookingSlot.capacity || "---"}</b>
                              <br />
                            </td>
                            <td>
                              <div className="social-links mt-2">
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClick4(bookingSlot.id)}
                                >
                                  <i className="bi bi-pencil"></i>
                                </a>
                                &nbsp;&nbsp;
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleDeleteWorkshop(bookingSlot.id)
                                  }
                                >
                                  <i className="bi bi-trash3"></i>
                                </a>
                                &nbsp;
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <h3 style={{ textAlign: "center" }}></h3>
                  )}
                </div> */}

                {showFields4 && (
                  <div>
                    <>
                      <div>
                        <div
                          class="col-md-12"
                          style={{ display: "flex", paddingLeft: "0px" }}
                        >
                          <div
                            class="form-group col-md-6"
                            style={{ paddingLeft: "0px" }}
                          >
                            <label class="small mb-1" for="inputFullName">
                              Select Date<font color="red"></font>
                            </label>
                            <input
                              class="form-control"
                              id="inputFullName"
                              type="date"
                              // value={eachSlot.startDate}
                              min={bookingDate}
                              value={bookingNewDate}
                              onChange={(e) =>
                                setBookingNewDate(e.target.value)
                              }
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <label class="small mb-1" for="inputFullName">
                              Select Start time <font color="red"></font>
                            </label>
                            <input
                              class="form-control"
                              id="inputFullName"
                              type="time"
                              // value={eachSlot.startTime}
                              value={bookingNewStartTime}
                              onChange={(e) =>
                                setBookingNewStartTime(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div
                          class="col-md-12"
                          style={{ display: "flex", paddingLeft: "0px" }}
                        >
                          <div
                            class="form-group col-md-6"
                            style={{ paddingLeft: "0px" }}
                          >
                            <label class="small mb-1" for="inputFullName">
                              Select End Time<font color="red"></font>
                            </label>
                            <input
                              class="form-control"
                              id="inputFullName"
                              type="time"
                              // value={eachSlot.endTime}
                              value={bookingNewEndTime}
                              onChange={(e) =>
                                setBookingNewEndTime(e.target.value)
                              }
                            />
                          </div>
                          <div class="form-group col-md-6">
                            <label class="small mb-1" for="inputFullName">
                              Enter Price <font color="red"></font>
                            </label>
                            <input
                              class="form-control"
                              id="inputFullName"
                              type="number"
                              // value={eachSlot.price}
                              value={bookingNewPrice}
                              onChange={(e) =>
                                setBookingNewPrice(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div class="form-group col-md-6">
                          <label class="small mb-1" for="inputFullName">
                            Enter Seating Capacity<font color="red"></font>
                          </label>
                          <input
                            class="form-control"
                            id="inputFullName"
                            type="number"
                            // value={eachSlot.capacity}
                            value={bookingNewCapacity}
                            onChange={(e) =>
                              setBookingNewCapacity(e.target.value)
                            }
                          />
                        </div>
                        <div style={{ display: "flex", marginBottom: "20px" }}>
                          <button
                            type="button"
                            style={{
                              marginLeft: "10px",
                              fontSize: "14px",
                              borderRadius: "4px",
                              backgroundColor: "#000",
                              color: "#fff",
                              border: "none",
                              padding: "5px 20px",
                            }}
                            // onClick={handleeUpdate}
                            onClick={() =>
                              handleUpdateWorkshop(
                                id2,
                                bookingNewDate,
                                bookingNewStartTime,
                                bookingNewEndTime,
                                bookingNewPrice,
                                bookingNewCapacity
                              )
                            }
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            onClick={handleCancelClick4}
                            style={{
                              marginLeft: "10px",
                              fontSize: "14px",
                              borderRadius: "4px",
                              backgroundColor: "lightgrey",
                              color: "#000",
                              border: "none",
                              padding: "5px 20px",
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </>
                  </div>
                )}

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Status:<font color="red"></font>
                  </label>
                  <div class="child ml-2">
                    <Select
                      value={newVenueStatus}
                      options={Status}
                      onChange={handleStatusChange}
                    ></Select>
                  </div>
                </div>
                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputFullName">
                    Select Instructor<font color="red">*</font>
                  </label>
                  <Select
                    options={venueOwner}
                    // options={filteredOptions}
                    onInputChange={handleInputChange}
                    value={selectedVenueOwner} // value prop for controlled component
                    onChange={handleVenueOwnerChange} // handle change function
                    getOptionLabel={(option) => (
                      <div>
                        <img
                          src={option.image}
                          style={{ width: "30px", marginRight: "10px" }}
                        />
                        {option.label}
                      </div>
                    )}
                    getOptionValue={(option) => option.value}
                    isSearchable
                  />
                </div>
              </form>
            </div>

            <div
              class="modal-footer"
              style={{
                padding: "2%",
                marginTop: "3%",
                borderTop: "solid 1px #7e7a7a8c",
              }}
            >
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
              >
                Close
              </button>

              {/* <div>
                <ThreeDots color="#000" height={50} width={50} />
              </div> */}

              <button
                id="btnAdd"
                type="button"
                class="btn btn-primary "
                style={{ background: "#000 ", border: "none" }}
                onClick={handleUpdate}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Update_venue;
